import type { StoreItem, StoreItemsByCategory } from '../types/get-store-items';
import { getDiscountPercent } from './promotion';
import { isFlagOn } from './store-benefits';

/** Teto de cards no carrossel: é vitrine, não cardápio. */
const MAX_HIGHLIGHTS = 10;

/**
 * Destaques da loja (PRAT-110): os mais pedidos e os com maior desconto, sem
 * repetir produto. Primeiro os mais pedidos, depois o maior desconto.
 */
export function pickHighlights(items: StoreItemsByCategory | undefined): StoreItem[] {
  if (!items) return [];

  const seen = new Set<string>();
  const candidates: { item: StoreItem; popular: boolean; percent: number }[] = [];

  Object.values(items).forEach(list => {
    (list ?? []).forEach(item => {
      if (!item?.id || seen.has(item.id)) return;
      seen.add(item.id);
      const popular = isFlagOn(item.is_popular);
      const percent = getDiscountPercent(item) ?? 0;
      if (popular || percent > 0) candidates.push({ item, popular, percent });
    });
  });

  return candidates
    .sort((a, b) => Number(b.popular) - Number(a.popular) || b.percent - a.percent)
    .slice(0, MAX_HIGHLIGHTS)
    .map(c => c.item);
}
